import React, {Component} from 'react';
import '../../Compact.css';

let _this;

class AgentsAtWorkCompact extends Component {

    constructor(props, context) {
        super(props);
        _this = this;
    }

    render() {
        return <div className="product-card">
            <div className="product-card-content">
                <div className="product-info">
                    <div>
                        <img style={{borderRadius: '10%', margin: '0 16px 0 16px'}}
                             className="roundrect"
                             src="/agents_at_work_icon.png"
                             align="left"
                             alt="app icon"
                             width="128"/>
                        <div>
                            <h2>Agents At Work</h2>
                            <h3>Your AI agents are working. You don't have to babysit them.</h3>
                        </div>
                    </div>
                    <br/>
                    <br/>
                    <div className="divider"></div>
                    <br/>
                    <div style={{margin: '0 24px 0 24px'}}>
                        <h4>MONITOR AND CONTROL CLAUDE CODE, CODEX, GEMINI CLI, GROK, CURSOR, AND
                            OLLAMA FROM YOUR PHONE</h4>
                    </div>

                    <div className="product-links" style={{margin: '16px 0 0 16px'}}>
                        <a href="https://apps.apple.com/us/app/agents-at-work-you-can-go/id6761508632"
                           target="_blank"
                           rel="noopener noreferrer">
                            <img src="/app_store.png" alt="itunes" height="36" hspace="5" vspace="5"/>
                        </a>
                        <a href="https://play.google.com/store/apps/details?id=com.answersolutions.agentsatwork"
                           target="_blank"
                           rel="noopener noreferrer">
                            <img src="/google_play.svg" alt="google play" height="36" hspace="5" vspace="5"/>
                        </a>
                    </div>
                    <div className="divider"></div>
                    <div className="product-footer">
                        <a href="https://www.producthunt.com/posts/agents-at-work-you-can-go" target="_blank"
                           rel="noopener noreferrer">
                            <img
                                src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=1177422&theme=light"
                                alt="Product Hunt"
                                className="product-hunt-button"
                                height="36"/>
                        </a>
                        <a href="#agents-at-work-product"
                           role="button"
                           className="learn-more-button"
                           onClick={() => _this.props.navigate('AgentsAtWorkProduct')}
                        >Learn More →</a>
                    </div>
                </div>
            </div>
        </div>
    }
}

export default AgentsAtWorkCompact;
